import { Injectable } from '@angular/core';
import { TextSectionResolverBase } from './text-section.resolver.base';
import { TextSectionService } from './text-section.service';



@Injectable({ providedIn: 'root' })
export class TextSectionResolver extends TextSectionResolverBase {

  constructor(protected service: TextSectionService) {
    super(service);
  }
}



